module.exports = __webpack_public_path__ + "img/hr_lang_invite.fc18859b.svg";